var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ICP-centent",style:({background:_vm.bgcClor,color:_vm.color})},[_vm._v(" Copyright © "+_vm._s(new Date().getFullYear())+" itgsa.com All rights reserved.      "),_c('a',{staticClass:"ICP-url",style:({color:_vm.color}),attrs:{"href":"http://beian.miit.gov.cn/"}},[_vm._v("京ICP备14038000号-18")]),_vm._v("      ")])
}
var staticRenderFns = []

export { render, staticRenderFns }